import LegalDocLayout from "@/pages/_legal/LegalDocLayout";

export default function CancellationPage() {
  return (
    <LegalDocLayout
      titleKey="legal.cancelTitle"
      introKey="legal.cancelIntro"
      prefix="c"
      countKey="legal.cancelSectionsCount"
      lastUpdated="2026-09-01"
    />
  );
}
